import { isPlatformBrowser } from '@angular/common';
import type { AfterViewInit, OnInit } from '@angular/core';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { LinkService } from '../../../services/link.service';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-long-term-service',
  imports: [SharedModule],
  templateUrl: './long-term-service.component.html',
  styleUrl: './long-term-service.component.scss',
})
export class LongTermServiceComponent implements OnInit, AfterViewInit {
  router = inject(Router);
  titleService = inject(Title);
  metaService = inject(Meta);
  linkService = inject(LinkService);
  showFullText = false;
  platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    // SEO: Set page title
    this.titleService.setTitle('Long-Term & Monthly Car Rental in Qatar | Q-Autos');

    // SEO: Set meta description with relevant keywords
    this.metaService.updateTag({
      name: 'description',
      content:
        'Long-term and monthly car rental in Qatar with Q-Autos. Flexible rental periods from 1 month to 12+ months. No hidden costs, simple booking, and the ability to change vehicles anytime. Perfect alternative to buying or leasing.',
    });

    // SEO: Open Graph tags for social sharing
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Long-Term & Monthly Car Rental in Qatar | Q-Autos',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Flexible long-term car rental in Qatar. Rent from 1 month with transparent pricing, no hidden costs, and the freedom to change vehicles anytime.',
    });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({
      property: 'og:url',
      content: 'https://qautos.com/long-term-service',
    });

    // SEO: Twitter Card tags
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Long-Term & Monthly Car Rental in Qatar | Q-Autos',
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content:
        'Flexible long-term car rental in Qatar with transparent pricing and no hidden costs.',
    });

    // SEO: Keywords meta tag
    this.metaService.updateTag({
      name: 'keywords',
      content:
        'long-term car rental Qatar, monthly car rental Qatar, car subscription Qatar, flexible car rental, corporate fleet rental Qatar, car rental without ownership',
    });

    // SEO: Robots meta tag
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
  }

  ngAfterViewInit(): void {
    // Only set canonical URL after view is initialized (browser only)
    if (isPlatformBrowser(this.platformId)) {
      this.linkService.setCanonicalUrl('/long-term-service');
    }
  }

  onContactUs(): void {
    this.router.navigateByUrl('/contact-us');
  }

  toggleText(): void {
    this.showFullText = !this.showFullText;
  }
}
